import React, { useCallback, useEffect } from 'react';
import { ResponsiveGrid } from '@fpxfd/next';
import PageHeader from '@/components/PageHeader';

import List from './components/index';
import styles from './index.module.scss';

const { Cell } = ResponsiveGrid;

const FpxDemo = () => {
  return (
    <div className={styles.fpxdemo}>
      <ResponsiveGrid>
        <Cell colSpan={12}>
          <List />
        </Cell>
      </ResponsiveGrid>
    </div>
  );
};

export default FpxDemo;
